<template>
  <div class="news-container">
    <div>
      <p>Publicerad: <strong>{{publiced}}</strong></p>
    </div>
    <div class="news-container__content">
      <div class="news-container__left-content">
        <img 
        :src="require(`../assets/images/${newsImg}`)"
        v-if="imgLeft"/>
        <div v-else>
          <h2>{{ title }}</h2>
          <p>
            {{ newsText }}  
          </p>
          <p v-if="externalLink !== undefined">
            <a :href="externalLink" target="_blank">{{ linkText }}</a>
          </p>
          <slot></slot>
        </div>
      </div>
      <div class="news-container__right-content">
        <div v-if="imgLeft">
          <h2>{{ title }}</h2>
          <p>
            {{ newsText }}  
          </p>
          <p v-if="externalLink">
            <a :href="externalLink" target="_blank">{{ linkText }}</a>
          </p>
          <slot></slot>
        </div>
        <img 
        :src="require(`../assets/images/${newsImg}`)"
        v-else/>
      </div>
    </div>
    <hr>
  </div>
</template>

<script>
export default {
  name: 'News',

  props: {
    publiced: String,
    title: String,
    newsText: String,
    newsImg: String,
    imgLeft: Boolean,
    externalLink: String,
    linkText: String
  }
  
}
</script>

<style lang="scss" scoped>
  .news-container {
   width: 75%;
   margin: auto;
   
   &__content {
    width: 100%;
    max-height: 400px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
   }

   &__left-content {
    max-width: 50%;
    max-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 70%;
      height: 100%;
      object-fit: cover;
      box-shadow: 2px 2px 6px #888888;
    }
   }

   &__right-content {
    width: 50%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 70%;
      height: 100%;
      object-fit: cover;
      box-shadow: 2px 2px 6px #888888;
    }
   }
   @media only screen and (max-width:600px) {
      width: 100%;

      &__content {
        flex-direction: column;

        img {
          display: none;
        }
      }
      &__left-content {
        max-width: 100%;
      }
      &__right-content {
        width: 100%;
      }
    }
  }
</style>